"use client";

import React from "react";
import { useEntityContextOptional } from "../../UniversalDetailPage/contexts/EntityContextProvider";
import { AskMeridianHeaderButton } from "../../UniversalDetailPage/components/AskMeridianHeaderButton";

/**
 * DetailModalHeaderActions component
 * Renders action buttons in the detail modal header
 * Currently includes the Ask Meridian button
 */
export function DetailModalHeaderActions() {
  const entity = useEntityContextOptional();

  // Only render the button if entity context is available
  if (!entity) {
    return null;
  }

  return (
    <div className="flex items-center gap-2">
      <AskMeridianHeaderButton />
    </div>
  );
}
